

window.equalizeProductTextHeight = function() {
  const elements = document.querySelectorAll(".product-card .text-block");
  let maxHeight = 0;

  elements.forEach(el => el.style.height = "auto");

  elements.forEach(el => {
    maxHeight = Math.max(maxHeight, el.offsetHeight);
  });

  elements.forEach(el => {
    el.style.height = maxHeight + "px";
  });
}

window.addEventListener("load", window.equalizeProductTextHeight);
window.addEventListener("resize", window.equalizeProductTextHeight);


window.updatePrice = function () {
    const container = document.querySelector('.discount__variantOption_wrapp .selected-option input:checked');
    if (container) {
        const price_of_main_prod = container.getAttribute('data-variant-price');

        const addToCartBtn = document.querySelector('.add-to-cart-button .add-to-cart-text__content');
        if (!addToCartBtn) return;

        const oldSpan = addToCartBtn.querySelector('.new-price-span');
        if (oldSpan) oldSpan.remove();
        const newSpanPrice = document.createElement('span');
        newSpanPrice.classList.add('new-price-span');
        newSpanPrice.textContent = price_of_main_prod;
        addToCartBtn.innerHTML = 'Add to cart';
        addToCartBtn.appendChild(newSpanPrice);

        console.log("price_of_main_prod", price_of_main_prod);
    }
};

window.refreshCart = async () => {
  try {
    window.disableCheckout(); 
    const res = await fetch('/');
    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const responseText = await res.text();
    const html = new DOMParser().parseFromString(responseText, 'text/html');

    const countEl = html.querySelector('.cart-bubble__text-count');
    const count = parseInt(countEl?.textContent?.trim() || '0', 10);

    console.log("cartRefresh called:", {html, count, countEl});
    console.log("count<><><><>",count);

    const selectors = ['.cart-drawer__inner'];

    for (const selector of selectors) {
      const target = document.querySelector(selector);
      const source = html.querySelector(selector);
    if (target && source) {
        target.replaceWith(source.cloneNode(true));
      }
    }
    document.querySelectorAll('#cart-bubble-text').forEach(el => {
        console.log("Element:", el, "Visible:", !!(el.offsetWidth || el.offsetHeight));
      el.textContent = count;
      el.classList.toggle('hidden', count <= 0);
    });
      window.enableCheckout(); 
  } catch (error) {
    console.error('Error refreshing cart:', error);
  } 
};


window.disableCheckout = async () =>{
  const btn = document.querySelector('#checkout');
  btn.setAttribute('disabled', true);
  console.log("checkout disabled");
}

 window.enableCheckout = async () =>{
  const btn = document.querySelector('#checkout');
  btn.removeAttribute('disabled');
  console.log("checkout enables");
}

document.addEventListener('DOMContentLoaded', function () {
  window.updatePrice();
  // window.collectionCustomFilter();
  if (typeof window.freeGift === "function") {
    window.freeGift();
  }

});


window.equalizeCardLinks = function () {
    const links = document.querySelectorAll(
      ".card-information .card-information__text a"
    );

    if (!links.length) return;

    let maxHeight = 0;

    // reset
    links.forEach(el => el.style.height = "auto");

    // get max height
    links.forEach(el => {
      maxHeight = Math.max(maxHeight, el.offsetHeight);
    });

    // apply
    links.forEach(el => {
      el.style.height = maxHeight + "px";
    });
  }

  window.addEventListener("load", window.equalizeCardLinks);
  window.addEventListener("resize", window.equalizeCardLinks);





document.addEventListener('DOMContentLoaded', function () {
  window.originalMainSlides =
    document.querySelector('.mainSwiper .swiper-wrapper').innerHTML;

  window.originalThumbSlides =
    document.querySelector('.thumbSwiper .swiper-wrapper').innerHTML;

  initGallerySwipers();

  const selectedValue =
    document.querySelector('.selected-option.variant-option__button-label input:checked')?.value;

  console.log(selectedValue);
  window.filterVariantImages(selectedValue);
});

window.filterVariantImages = function(selectedValue) {

  console.log('Selected Variant:', selectedValue);

  mainSwiper.destroy(true, true);
  thumbSwiper.destroy(true, true);

  const mainWrapper = document.querySelector('.mainSwiper .swiper-wrapper');
  const thumbWrapper = document.querySelector('.thumbSwiper .swiper-wrapper');

  // Restore original slides
  mainWrapper.innerHTML = window.originalMainSlides;
  thumbWrapper.innerHTML = window.originalThumbSlides;

  const mainSlides = mainWrapper.querySelectorAll('.swiper-slide');
  const thumbSlides = thumbWrapper.querySelectorAll('.swiper-slide');

  let hasMatch = false;
  let hasEmptyAlt = false;

  // Check conditions
  mainSlides.forEach(slide => {
    const alt = slide.dataset.alt?.trim() || '';

    if (!alt) {
      hasEmptyAlt = true;
    }

    if (alt === selectedValue) {
      hasMatch = true;
    }
  });

  console.log('hasMatch:', hasMatch);
  console.log('hasEmptyAlt:', hasEmptyAlt);

  // If no match OR any image has no alt => show all
  if (!hasMatch || hasEmptyAlt) {
    console.log('Showing all images');
    initGallerySwipers();
    return;
  }

  // Filter Main Slides
  mainSlides.forEach(slide => {
    const alt = slide.dataset.alt?.trim();

    if (alt !== selectedValue) {
      slide.remove();
    }
  });

  // Filter Thumb Slides
  thumbSlides.forEach(slide => {
    const alt = slide.dataset.alt?.trim();

    if (alt !== selectedValue) {
      slide.remove();
    }
  });

  console.log('Showing variant specific images');

  initGallerySwipers();

    const dialogThumbnails = document.querySelectorAll('.dialog-thumbnails-list__thumbnail');
    const zoomableMedia = document.querySelectorAll('.product-media-container--zoomable');

    const hasDialogMatch = [...dialogThumbnails].some(thumbnail =>
      (thumbnail.dataset.alt?.trim() || '') === selectedValue
    );

    console.log('hasDialogMatch:', hasDialogMatch);

    // Reusable function
    const toggleElements = (elements) => {
      elements.forEach((element) => {
        const alt = element.dataset.alt?.trim() || '';

        if (!hasDialogMatch) {
          // No matching thumbnail -> show all
          element.style.display = '';
        } else {
          // Show only matching elements
          element.style.display = alt === selectedValue ? '' : 'none';
        }
      });
    };

    // Apply to both selectors
    toggleElements(dialogThumbnails);
    toggleElements(zoomableMedia);
};

function initGallerySwipers() {
  window.thumbSwiper = new Swiper('.thumbSwiper', {
    direction: 'vertical',
    slidesPerView: 6,
    spaceBetween: 12,
    watchSlidesProgress: true,
    freeMode: true,

    breakpoints: {
      0: {
        direction: 'horizontal',
        slidesPerView: 6,
      },
      768: {
        direction: 'vertical',
        slidesPerView: 6,
      },
    },
  });

  window.mainSwiper = new Swiper('.mainSwiper', {
    spaceBetween: 10,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    thumbs: {
      swiper: window.thumbSwiper,
    },
  });
}